import { memoize } from 'lodash';
import React from 'react';
import { ProjectHours } from 'api/project';
import { StatusPopover } from 'components/molecules/status-popover';
import { useTranslation } from 'hooks/use-translation';
import { Cell } from './cell';
import { Info } from './info';

export const renderProjectHours = memoize(
  (projectHours: ProjectHours) => (
    <StatusPopover
      title={useTranslation('projects.list.project_hours')}
      subTitle={projectHours.project_name}
      content={<Info projectHours={projectHours} />}
      placement="leftTop"
    >
      <div>
        <Cell projectHours={projectHours} />
      </div>
    </StatusPopover>
  ),
  ({ total_minutes, budget_hours, project_name }: ProjectHours) =>
    [total_minutes, budget_hours, project_name].join('_'),
);
export * from './progress';
export * from './widget';
